import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class ForwardedCvSend extends ApplicationRecord {
  static jsonapiType = "forwarded_cvs/send";

  @Attr() emailAddresses: string[];

  @Attr() applicationId: number;

  @Attr() candidateId: number;
}

export default ForwardedCvSend;
